<template>
  <div v-if="pageLoading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <div class="ui form" style="margin-bottom: 30px;">
      <div class="required four fields">
        <div class="field">
          <label for="clinic">Clinic</label>
          <select
            class="ui fluid search dropdown"
            id="clinic-search"
            v-model="selectedClinicId"
            name="clinic"
          >
            <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">
              {{ clinic.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label for="clinic">Doctor</label>
          <select
            class="ui fluid search dropdown"
            id="doctor-search"
            v-model="selectedDoctorId"
            name="clinic"
          >
            <option :value="doctor.id" v-for="doctor in doctors" :key="doctor.id">
              {{ doctor.user.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label for="purchasedDate">From Date</label>
          <div style="text-align: center" class="ui calendar" :id="'from-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'From Date'"
                     readonly=""
                     name="formDate">
            </div>
          </div>
        </div>
        <div class="field">
          <label for="purchasedDate">To Date</label>
          <div style="text-align: center" class="ui calendar" :id="'to-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'To Date'"
                     readonly=""
                     name="toDate">
            </div>
          </div>
        </div>
      </div>
      <div class="ui blue right floated submit button"
           style="background-color: #092442"
           @click="getVisitsReport()">
        Submit
      </div>
    </div>
    <br>
    <div class="ui divider"></div>
    <br>
    <div v-if="reportLoading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else>
      <table
        class="ui center aligned celled very compact table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th style="width:8%">Id</th>
            <th>Note</th>
            <th>Package</th>
            <th style="width:8%">Quantity</th>
            <th style="width:10%">Selling Price</th>
            <th style="width:10%">Cost Price</th>
            <th style="width:6%">Doctor Prcentage</th>
            <th style="width:8%">Discount</th>
            <th style="width:8%">Doctor Profit</th>
            <th style="width:10%">Clinic Profit</th>
          </tr>
        </thead>
        <tbody v-for="visit in visits" :key="visit.id">
          <tr 
            v-for="(visitDetail, index) in visit.visit_details" 
            :key="index"
          >
            <td 
              v-if="index === 0" 
              :rowspan="visit.visit_details.length"
              class="strong-border"
            >
              {{ visit.id }}
            </td>
            <td 
              v-if="index === 0" 
              :rowspan="visit.visit_details.length"
              class="strong-border"
            >
              {{ visit.note || '-'}}
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :class="{'strong-border': visit.visit_details.length === index + 1}"
            >
              {{ packagesById[visitDetail.package_id].name }}
            </td>
            <td :class="{'strong-border': visit.visit_details.length === index + 1}">
              {{ visitDetail.quantity }}
            </td>
            <td :class="{'strong-border': visit.visit_details.length === index + 1}">
              <div class="ui fluid input very compact focus">
                <input
                  type="number"
                  style="text-align: center"
                  v-model="visitDetail.visit_cost.total_selling_price"
                />
              </div>
            </td>
            <td :class="{'strong-border': visit.visit_details.length === index + 1}">
              <div class="ui fluid input very compact focus">
                <input
                  type="number"
                  style="text-align: center"
                  v-model="visitDetail.visit_cost.total_cost"
                />
              </div>
            </td>
            <td :class="{'strong-border': visit.visit_details.length === index + 1}">
              <div class="ui fluid input very compact focus">
                <input
                  type="number"
                  style="text-align: center"
                  v-model="visitDetail.visit_cost.doctor_percentage"
                />
              </div>
            </td>
            <td :class="{'strong-border': visit.visit_details.length === index + 1}">
              <div class="ui fluid input focus">
                <input
                  type="number"
                  style="text-align: center"
                  v-model="visitDetail.visit_cost.discount"
                />
              </div>
            </td>
            <td :class="{'strong-border': visit.visit_details.length === index + 1}"> 
              {{ formatPrice(computeDoctorProfit(visitDetail.visit_cost)) }}
            </td>
            <td :class="{'strong-border': visit.visit_details.length === index + 1}"> 
              {{ formatPrice(computeClinicProfit(visitDetail.visit_cost)) }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th :colspan="8">
              Totals
            </th>
            <th>
              {{ formatPrice(computeTotalProfits().doctorProfit) }}
            </th>
            <th>
              {{ formatPrice(computeTotalProfits().netProfit) }}
            </th>
          </tr>
        </tfoot>
      </table>
    
      <div class="ui blue right floated submit button"
           style="background-color: #092442"
           @click="saveVisitCosts()">
        Save changes
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  data() {
    return {
      pageLoading: true,
      reportLoading: true,
      from_date: window.moment().startOf('day').toString(),
      to_date: window.moment().endOf('day').toString(),
      selectedClinicId: null,
      selectedDoctorId: null,
      packagesById: {},
      choosenClinicId: null,
      doctors: [],
      visits: []
    }
  },
  mounted () {
    this.$http.get('doctors/list').then(response => {
      this.doctors = response.data
      this.selectedClinicId = this.clinics[0].id
      this.selectedDoctorId = this.doctors[0].id
      this.pageLoading = false
      this.reportLoading = false
      this.initGUI()
    })
  },
  methods: {
    getVisitsReport () {
      this.reportLoading = true
      this.choosenClinicId = this.selectedClinicId
      this.$http.get('financial/doctor_visits/report', {
        params: {
          from_date: this.from_date,
          to_date: this.to_date,
          clinic_id: this.selectedClinicId,
          doctor_id: this.selectedDoctorId
        }
      }).then(response => {
        this.packagesById = response.data.meta.reduce((obj, pk) => ({ ...obj, [pk.id]: pk }), {})
        this.visits = response.data.visits
        this.reportLoading = false
        this.initGUI()
      })
    },
    getDoctorsList() {
      return ;
    },
    initGUI() {
      console
      this.$nextTick(() => {
        $('#clinic-search').dropdown()
        $('#clinic-search').dropdown('set selected', this.selectedClinicId)

        $('#doctor-search').dropdown()
        $('#doctor-search').dropdown('set selected', this.selectedDoctorId)

        $('#from-date').calendar({
          type: 'date',
          onChange: (date) => {
            this.from_date = date
          }
        })

        $(`#from-date`).calendar(
          'set date',
          this.from_date
        )

        $('#to-date').calendar({
          type: 'date',
          onChange: (date) => {
            this.to_date = date
          }
        })
        
        $(`#to-date`).calendar(
          'set date',
          this.to_date
        )
      })
    },
    computeDoctorProfit(visitCost) {
      visitCost.doctor_profit = Number(this.computeGrossProfit(visitCost)) * Number(visitCost.doctor_percentage)
      return visitCost.doctor_profit
    },
    computeGrossProfit(visitCost) {
      return Number(visitCost.total_selling_price) - Number(visitCost.total_cost) - Number(visitCost.discount)
    },
    computeClinicProfit(visitCost) {
      const grossProgit = this.computeGrossProfit(visitCost)
      const doctorProfit = this.computeDoctorProfit(visitCost)
      visitCost.net_profit = grossProgit - doctorProfit
      return visitCost.net_profit
    },
    computeTotalProfits () {
      let doctorProfit = 0
      let netProfit = 0

      const visitCosts = this.visits.flatMap(v => v.visit_details).map(vd => vd.visit_cost)
      visitCosts.forEach(visitCost => {
        doctorProfit += this.computeDoctorProfit(visitCost)
        netProfit += this.computeClinicProfit(visitCost)
      })

      return { doctorProfit, netProfit }
    },
    saveVisitCosts() {
      this.$swal({
        title: 'You are going to change costs values',
        type: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#092442',
        preConfirm: () => {
          return this.$http.put('visits/costs/update', {
            costs: this.visits.flatMap(v => v.visit_details).map(vd => vd.visit_cost),
            clinic_id: this.choosenClinicId
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: 'Costs updated Successfully',
            type: 'success'
          })
        }
      })
    }
  },
}
</script>

<style scoped>
.centered-header {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.strong-border {
  border-bottom: 2px solid rgba(34,36,38,.3);
}
</style>



// WEBPACK FOOTER //
// src/components/financial_system/FinilizeVisitsReport.vue